import pushGTMEvent from '../../util/helper/pushGTMEvent';
import getHULA from '../../Action/getHULA/getHULA';
import handleAdminStatusChange from '../../handler/handleAdminStatusChange';
import handleInputEmailChange from '../../handler/handleInputEmailChange';
import rules from '../../Action/rules/rules'
import { isEmpty } from "../../util/util";
import { isRUorJA } from '../../App/App.config';

const configContents = ({ state: { langStrings, caseError, currentHULADetails }, dispatch }) => [
  {
    isTitle: true,
    description: langStrings
      ? langStrings.authorizationRequestScreen.pageTitle
      : '3. Authorization for this request',
    paragraphStyle: { marginBottom: isRUorJA ? '-20px' : '0px' },
  },
  {
    description: langStrings
      ? langStrings.authorizationRequestScreen.selectOne
      : 'Please select one',
    endWithRedStar: true,
    style: { fontWeight: 'bold' },
    paragraphStyle: { marginBottom: '20px' },
  },
  {
    isRadioInput: true,
    options: [
      langStrings
        ? langStrings.authorizationRequestScreen.option1
        : 'I confirm that I’m the administrator, contract manager, or software coordinator for this product.',
      langStrings
        ? langStrings.authorizationRequestScreen.option2
        : 'I confirm that I’m making this request on behalf of the administrator, contract manager, or software coordinator and their email is:',
    ],
    handleChange: (e) => handleAdminStatusChange(e, dispatch),
  },{
    isShown: !isEmpty(caseError.errorDesc),
    description: caseError.errorDesc,
    style: { fontWeight: 400, color: '#ec4a41', fontSize: '14px' },
    paragraphStyle: { marginBottom: '5px', marginLeft: '25px'},
    id: 'adsktm-hula-serial-number-error',
  },
  {
    isTextInput: true,
    placeholder: langStrings
      ? langStrings.authorizationRequestScreen.enterEmail
      : 'Enter email',
    handleChange: e => handleInputEmailChange(e, dispatch),
    value: currentHULADetails.authEmail,
    paragraphStyle: { marginBottom: '30px', marginLeft: '25px' },
    handleValidation: () => {},
    handleSubmit: () => {},
    isError: !isEmpty(caseError.errorDesc),
  },
];

const configFooter = ({
  state: {
    credentials,
    langStrings,
    user,
    currentHULADetails,
    hasExtension,
    caseError,
  }, dispatch }) => {
  const { authEmail } =currentHULADetails;
  return {
    requiredDisclaimer: true,
    nextButtonContent: langStrings ? langStrings.buttons.submitButton : 'SUBMIT',
    hasQuestion: true,
    hasExtension,
    handleBack: () => {
      pushGTMEvent('ProductInfo');
      dispatch({ type: 'GO_TO_PRODUCT_INFO_PAGE' });
    },
    handleNext: async () => {
      // const response = { status: 200, errors: [{code: 'HL-01'}] }; // Make HULA call to backend here
      dispatch({ type: 'GO_TO_SPIN_PAGE'});
      try {
        return await getHULA(langStrings, user, currentHULADetails, dispatch, credentials);
      } catch(err) {
        console.log('Error : ', err);
        return dispatch({ type: 'GO_TO_ERROR_PAGE', payload: 'generalError' })
      }
    },
    enableNextButton: (authEmail.match(rules.authEmail.pattern) && 
      caseError.errorDesc.length === 0) || 
      currentHULADetails.isUserAdmin
    ,
    handleSupportAnalytics: () => pushGTMEvent('ContactSupport'),
  }
};
  
export default {
  configContents,
  configFooter,
};
